<template>
  <div>
    <div class="form-container">
      <div class="el-descriptions-title">检测内容和结果</div>
      <eTableList :table-data="tableData" :table-label="tableLabel" :index-show="true">
        <template #detectResult="{ scope: { row } }">
          <el-input v-model="row.detectResult" type="text" />
        </template>
        <template #qualifiedSign="{ scope: { row } }">
          <el-radio-group v-model="row.qualifiedSign" @input="(e) => onChange(e, row)">
            <el-radio :label="1">合格</el-radio>
            <el-radio :label="0">不合格</el-radio>
          </el-radio-group>
        </template>
      </eTableList>
    </div>
    <div class="form-container">
      <div class="el-descriptions-title">产品性能测试得分</div>
      <eTableListMerge
        :table-data="performanceTableData.filter((item) => !item.hidden)"
        :table-label="performanceTableLabel"
        :index-show="false"
        :right-span-method="objectSpanMethod"
      >
        <template #index="{ scope: { row } }">
          <span>{{ row.index }}</span>
        </template>
        <template #realTestVal="{ scope: { row } }">
          <el-input v-model="row.realTestVal" type="text" />
        </template>
        <template #realScore="{ scope: { row, $index } }">
          <el-input v-model="row.realScore" :class="{ error: row.error }" type="text" @blur="onBlur(row, $index)" />
        </template>
        <template #realRemark="{ scope: { row } }">
          <el-input v-model="row.realRemark" :max-length="1000" type="text" />
        </template>
      </eTableListMerge>
      <div class="total-score">总分：{{ totalScore }}</div>
    </div>
    <div class="form-container">
      <div class="el-descriptions-title">录入改进建议</div>
      <el-input v-model="remark" type="textarea" :maxlength="1000" show-word-limit />
    </div>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list';
import eTableListMerge from '@/modules/projectA/components/common/e-table-list-merge';
import Api from '@/modules/projectA/api/ESorganization';
import utils from '@/modules/projectA/utils/utils';

export default {
  name: 'DetectionContent',
  components: { eTableList, eTableListMerge },
  props: {
    applyItemPriceIdSet: {
      type: Array,
      default: () => {
        return [];
      },
    },
    applyItemPriceGradeRemark: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData: [],
      tableLabel: [
        { label: '检测项目', param: 'detectItem', align: 'center', width: 130 },
        {
          label: '技术要求',
          param: 'techRequirement',
          align: 'center',
          tooltip: true,
        },
        {
          label: '检测依据',
          param: 'reference',
          align: 'center',
          minWidth: 110,
        },
        {
          label: '检测结果',
          slot: 'detectResult',
          align: 'center',
          minWidth: 120,
        },
        {
          label: '合格情况',
          slot: 'qualifiedSign',
          align: 'center',
          minWidth: 130,
        },
      ],
      performanceTableData: [],
      performanceTableLabel: [
        { label: '序号', slot: 'index', align: 'center', width: 50 },
        {
          label: '评分项目',
          param: 'scoreName',
          align: 'center',
          width: 170,
          render({ scoreName, score }) {
            return `${scoreName}（分值：${score}）`;
          },
        },
        {
          label: '测试要求',
          param: 'scoreRemark',
          align: 'center',
          tooltip: true,
        },
        {
          label: '分级范围',
          param: 'gradeRange',
          align: 'center',
          width: 140,
          render({ gradeRange, gradeRangeScore }) {
            return `${gradeRange}（分值：${gradeRangeScore}）`;
          },
        },
        {
          label: '实际检测值',
          slot: 'realTestVal',
          align: 'center',
          width: 120,
        },
        { label: '得分', slot: 'realScore', align: 'center', width: 120 },
        { label: '改进建议', slot: 'realRemark', align: 'center', width: 120 },
      ],
      remark: '',
    };
  },
  computed: {
    totalScore() {
      let score = 0;
      this.performanceTableData.forEach((item) => {
        if (item.span && utils.isNumber(item.realScore) && !item.hidden) {
          score += Number(item.realScore);
        }
      });
      score = score.toFixed(2);
      this.$emit('setScore', score);
      return score;
    },
  },
  watch: {
    applyItemPriceGradeRemark: {
      immediate: true,
      handler(newVal) {
        this.remark = newVal;
      },
    },
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * 合并单元格
     * @param row
     * @param columnIndex
     * @returns {{colspan: number, rowspan: *}|{colspan: number, rowspan: number}}
     */
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex < 3) {
        if (row.span) {
          return {
            rowspan: row.span,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
      if (columnIndex > 3) {
        if (row.span) {
          return {
            rowspan: row.span,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
    /**
     * 改变合格情况
     * @param v
     * @param data
     */
    onChange(v, data) {
      let i = 1;
      this.performanceTableData.forEach((item, index) => {
        // 修改当前评分项目是否隐藏
        if (item.evaluationProductPerformanceId === data.id) {
          this.$set(this.performanceTableData[index], 'hidden', v === 0);
        }
        // 修改序号
        this.$set(this.performanceTableData[index], 'index', i);
        // 没有隐藏并且下一个的id不等于当前id
        if (
          !item.hidden &&
          item.evaluationProductPerformanceId !== this.performanceTableData[index + 1]?.evaluationProductPerformanceId
        ) {
          i++;
        }
      });
      console.log(`this.performanceTableData`, this.performanceTableData);
    },
    /**
     * 得分失去焦点
     * @param data
     * @param index
     */
    onBlur(data, index) {
      const reg = /^\d+(\.\d{1,2})?$/;
      const { realScore, score } = data;
      if (!realScore || !reg.test(realScore) || Number(realScore) > Number(score) || Number(realScore) < 0) {
        this.$set(data, 'error', true);
      } else {
        this.$set(data, 'error', false);
      }
    },
    async getData() {
      const { evaluationItemId, evaluateItemPriceId, id } = this.$route.query;
      const res = await Api.getStructProductTestReviewVO({
        evaluationItemId,
        evaluateItemPriceId,
        applyItemPriceId: id,
        applyItemPriceIdSet: this.applyItemPriceIdSet,
      });
      if (res.code === '200') {
        const { evaluationProductPerformanceVOList, evaluationProductBenchmarkVOList } = res.data;
        this.tableData = evaluationProductPerformanceVOList;
        const list = [];
        // 序号
        let i = 1;
        evaluationProductBenchmarkVOList?.forEach((item, index) => {
          item.evaluationProductPerformanceGradeList?.forEach((item2, index2) => {
            list.push({
              ...item2,
              ...item,
              gradeRangeScore: item2.score,
              span: index2 === 0 ? item.evaluationProductPerformanceGradeList.length : 0,
              index: i,
              hidden: evaluationProductPerformanceVOList[index].qualifiedSign !== 1,
            });
            if (
              index2 === item.evaluationProductPerformanceGradeList.length - 1 &&
              evaluationProductPerformanceVOList[index].qualifiedSign === 1
            ) {
              i++;
            }
          });
        });
        this.performanceTableData = list;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../components/common';

.total-score {
  padding-right: 10px;
  text-align: right;
  line-height: 40px;
  font-size: 14px;
  color: #333333;
  border-bottom: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

::v-deep.error > input {
  border-color: #e50113 !important;
}
</style>
